import type { Dayjs } from '~/services/TimeService';

export const CHARTER_FEEDER_QUERY_KEY = ['charterFeederPrices'] as const;

export const FEEDER_CODE_PATTERN = /^\S{3}$/;
export const ROUTE_AIRPORT_CODE_PATTERN = /^\S{3}$/;
export const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const AIRPORT_CODE_LENGTH = 3;
export const DEFAULT_CHARTER_FEEDER_START_DATE = '2026-05-18';
export const DEFAULT_CHARTER_FEEDER_DEPARTURE_INTERVAL_DAYS = 7;
export const DEFAULT_CHARTER_FEEDER_RETURN_OFFSET_DAYS = 6;
export const DEFAULT_CHARTER_FEEDER_WILDCARD_AIRPORT_CODE = 'ALL';
export const MEL_FEEDER_ORIGIN_CODE = 'MEL';
export const DEFAULT_FEEDER_ORIGIN_CODES = [MEL_FEEDER_ORIGIN_CODE, 'SYD', 'BNE', 'ADL'] as const;
export const DEFAULT_FEEDER_ORIGIN_CODE_SET = new Set<string>(DEFAULT_FEEDER_ORIGIN_CODES);

export type AddRowDirection = 'xToMel' | 'melToX' | 'custom';

export interface AddRowFormState {
  date: Dayjs | null;
  direction: AddRowDirection;
  customOriginAirportCode: string;
  customDestinationAirportCode: string;
}

export const DEFAULT_ADD_ROW_FORM: AddRowFormState = {
  date: null,
  direction: 'xToMel',
  customOriginAirportCode: '',
  customDestinationAirportCode: '',
};

export const MAX_GRID_HEIGHT = 760;

export function isDefaultFeederOriginCode(value: string): boolean {
  return DEFAULT_FEEDER_ORIGIN_CODE_SET.has(value.trim().toUpperCase());
}
